import {PromotionTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//tracker.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {TrackPromotions} from './TrackPromotions';

interface TrackBrandLogoProps {
  promotionTrackingData: PromotionTracker | undefined;
  promoPath: string;
  streamPosition: number;
  children: React.ReactNode;
}

export const TrackLogoSectionItem = ({
  children,
  promotionTrackingData,
  promoPath,
  streamPosition,
}: TrackBrandLogoProps) => {
  const promoId = promotionTrackingData?.promotionId ?? '';
  const promoName = promotionTrackingData?.promotionName ?? '';
  if (!promoId && !promoName) {
    // Catching cases where BrandLogos have no promotionTrackingData, so it
    // won't fail the view_promotion event
    return <>{children}</>;
  }

  return (
    <TrackPromotions
      promotion={{
        source: TrackingPromotionCreative.BrandReco,
        brand: {
          id: Number(promoId),
          name: promoName,
          path: promoPath,
        },
      }}
      streamPosition={streamPosition}
      triggerOnce
    >
      {children}
    </TrackPromotions>
  );
};
